import React, { useEffect } from 'react';
import {Button, Dialog, DialogContent, Slide, DialogTitle, DialogActions} from '@material-ui/core/';
import useStyles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function Modal({open, closeModal, children, maxWidth, fullScreen, titleToolbar, iconToolbar, showToolbar, fullWidth, backgroundColor}) {
    let buttonYes = React.createRef();
    const classes = useStyles();

    useEffect(() => {
        if (buttonYes.current!==null)
            buttonYes.current.focus();
    });
    const [scroll, setScroll] = React.useState('paper');
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
      if (open) {
        const { current: descriptionElement } = descriptionElementRef;
        if (descriptionElement !== null) {
          descriptionElement.focus();
        }
      }
    }, [open]);    
    return (
        <Dialog 
            open={open}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            fullScreen={fullScreen}
            scroll={scroll}
            TransitionComponent={Transition}
            keepMounted
            onClose={()=>closeModal(false)}
            aria-labelledby="customized-dialog-title"
            style={{padding: 0}}
        >
            {
                titleToolbar && (                    
                    <DialogTitle id="customized-dialog-title" onClose={closeModal}>{titleToolbar}</DialogTitle>
                )
            }
            <DialogContent dividers>
                {children}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={closeModal} color="primary">Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
}

Modal.defaultProps = {
    maxWidth: 'xs',
    fullScreen: false,
    showToolbar: true,
    fullWidth: false,
};

export default Modal;